module.exports = __webpack_public_path__ + "img/Chic.08b9a96.jpg";